import PDFReportRoute from './PDFReportRoute';

export default {
  name: 'PDFReportRoute',
  location: '/le/pdf-report',
  component: PDFReportRoute,
};
